import type { MetaDataPropertyTypes } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { PropertyDataType } from "types/qbank/propertyDataType";

import Text from "./inputs/Text";
import Number from "./inputs/Number";
import Checkbox from "./inputs/Checkbox";
import Keywords from "./inputs/Keywords";
import DateSelect from "./inputs/Date";
import Dropdown from "./inputs/Dropdown";
import Hierarchical from "./inputs/Hierarchical";
import Decimal from "./inputs/Decimal";

export default function AdvancedSearchInput(props: {
  systemName: string;
  propertyTypes: MetaDataPropertyTypes;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setInputValues: (values: { [key: string]: any }) => void;
  value: any;
}) {
  function setValue(systemName: string, value: any) {
    props.setInputValues((current: { [key: string]: any }) => {
      let clone = { ...current };
      if ((value && value.length > 0) || typeof value === 'boolean' || (typeof value === 'number' && !isNaN(value))) {
        clone[systemName] = value;
      }
      else {
        delete clone[systemName]
      }
      return clone;
    });
  }

  if (!props.propertyTypes[props.systemName]) {
    //PropertyType deleted after being added to config?
    return <></>;
  }

  if (props.propertyTypes[props.systemName].definition.array) {
    if (props.propertyTypes[props.systemName].definition.hierarchical) {
      return (
        <Hierarchical
          propertyType={props.propertyTypes[props.systemName]}
          setCriteria={props.setCriteria}
          values={props.value}
          setValues={(values: string[]) => setValue(props.systemName, values)}
          isMulti={
            props.propertyTypes[props.systemName].definition.multiplechoice
          }
        />
      );
    } else if (
      props.propertyTypes[props.systemName].definition.options?.length
    ) {
      return (
        <Dropdown
          propertyType={props.propertyTypes[props.systemName]}
          setCriteria={props.setCriteria}
          value={props.value}
          setValue={(value: string) => setValue(props.systemName, value)}
          isMulti={
            props.propertyTypes[props.systemName].definition.multiplechoice
          }
        />
      );
    } else {
      return (
        <Keywords
          propertyType={props.propertyTypes[props.systemName]}
          setCriteria={props.setCriteria}
          value={props.value}
          setValue={(value: string) => setValue(props.systemName, value)}
        />
      );
    }
  } else if (
    props.propertyTypes[props.systemName].type === PropertyDataType.STRING
  ) {
    return (
      <Text
        propertyType={props.propertyTypes[props.systemName]}
        setCriteria={props.setCriteria}
        value={props.value}
        setValue={(value: string) => setValue(props.systemName, value)}
      />
    );
  } else if (
    props.propertyTypes[props.systemName].type === PropertyDataType.INTEGER
  ) {
    return (
      <Number
        propertyType={props.propertyTypes[props.systemName]}
        setCriteria={props.setCriteria}
        value={props.value}
        setValue={(value: number) => setValue(props.systemName, value)}
      />
    );
  }else if (
    props.propertyTypes[props.systemName].type === PropertyDataType.DECIMAL
  ) {
    return (
      <Decimal
        propertyType={props.propertyTypes[props.systemName]}
        setCriteria={props.setCriteria}
        value={props.value}
        setValue={(value: number) => setValue(props.systemName, value)}
      />
    );
  } else if (
    props.propertyTypes[props.systemName].type === PropertyDataType.BOOLEAN
  ) {
    return (
      <Checkbox
        propertyType={props.propertyTypes[props.systemName]}
        setCriteria={props.setCriteria}
        checked={!!props.value}
        setChecked={(checked: boolean) => setValue(props.systemName, checked)}
      />
    );
  } else if (
    props.propertyTypes[props.systemName].type === PropertyDataType.DATETIME
  ) {
    return (
      <DateSelect
        propertyType={props.propertyTypes[props.systemName]}
        setCriteria={props.setCriteria}
        value={props.value}
        setDate={(date?: string) => setValue(props.systemName, date)}
      />
    );
  }

  return <>(Unknown property type)</>;
}
